export const enum UIType {
  'user' = 'user',
  'admin' = 'admin',
  'guess' = 'guess',
}
